








import Vue from 'vue';
import MapsGenerator from './components/MapsGenerator.vue';

export default Vue.extend({
  name: 'App',

  components: {
    MapsGenerator,
  },

  data: () => ({
    //
  }),
});
